export default {
  welcomes: 'Chào mừng bạn đến với phần phụ trợ, vui lòng chọn các thanh menu khác ở bên trái',
  rules: {
    username: 'tài khoản không được bỏ trống！',
    password: 'mật khẩu không được bỏ trống！',
    code: 'mã xác nhận không được bỏ trống！',
    form: {
      assist: 'Hỗ trợ',
      system: '商户管理后台',
      Login: 'Đăng nhập',
      UserName: 'Nhập tên đăng nhập',
      Password: 'Nhập mật khẩu',
      verification: 'Nhập mã xác minh Google',
      Forgotpassword: '忘记秘密?',
      btnlogin: 'Đăng nhập',
      label: 'Đơn giản, Siêu tốc, Mượt mà',
      accountName: 'Tên đăng nhập',
      password: 'Mật khẩu',
      GoogleCode: 'Xác minh Google'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/login.js